import { PropertyBase } from './property-base.model';

export class ImageProperty extends PropertyBase {
  public original?: string | number;

  constructor(data: any = {}) {
    super();
    this.title = data.title || 'Image';
    this.value =
      typeof data.value === 'string' || data.value instanceof String || data.value > 0
        ? data.value
        : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    if (
      (typeof data.original === 'string' && data.original.trim()) ||
      (typeof data.original === 'number' && Number.isFinite(data.original) && data.original > 0)
    ) {
      this.original = data.original;
    }
  }
}
